<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .new{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:top;
    width: 100%;
    overflow: hidden;
  }

  .new .navbox{
    background-color: #c42428;
  }
  .new .nav{
    /*background:url('../assets/img/navbg.png')no-repeat;*/
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .new .nav img{
    float: left;
    /*margin-left: 160px;*/
    margin-top: 35px;
    margin-right: 90px;
  }
  .new .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .new .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 140px;
    text-align: center;
    line-height: 120px;
    color: #ebbfbf;
    font-size: 20px;
    font-weight: 900;
    cursor: pointer;
  }
  .new .nav ul li:hover{
    /*background:url("../assets/img/hover.png")no-repeat;*/
    background-color: #b62125;
    color: #fffefe;
    background-position: 0 21px;
  }
  .new .nav ul li.on{
    /*background:url("../assets/img/hover.png")no-repeat;*/
    background-color: #b62125;
    color: #fffefe;
    background-position: 0 21px;
  }

  .new .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .new .content {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 195px;
  }
  .new .content .title{
    margin-top: 100px;
    color: #191919;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .new .content .title img{
    margin-right: 15px;
  }
  .new .content .newList li{
    padding: 30px;
    overflow: hidden;
    background-color: #ffffff;
    margin-bottom: 15px;
  }
  .new .content .newList li img{
    float: left;
    width: 500px;
    height: 277px;
  }
  .new .content .newList li .text{
    float: right;
    width: 580px;
  }
  .new .content .newList li .text .title1{
    font-size: 24px;
    color: #333333;
    font-weight: 900;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 65px;
  }
  .new .content .newList li .text .title2{
    margin-top: 35px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    overflow: hidden;
    font-size: 14px;
    color: #949494;
    height: 150px;
  }
  .new .content .newList li .text .gameIcon{
    color: #333333;
    font-size: 14px;
  }
  .new .content .newList li .text .gameIcon img{
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .new .content .newList li .text .gameIcon span{
    float: right;
    font-size: 14px;
    color: #777777;
  }

  .new .content .pagination{
    margin-top: 60px;
    overflow: hidden;
    position: absolute;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
  }
  .new .content .pagination li{
    float: left;
    width: 38px;
    height: 38px;
    background: #ffffff;
    margin-right: 12px;
    text-align: center;
    line-height: 38px;
    color: red;
  }
  .new .content .pagination li.up{
    background: url("../assets/img/up.png")no-repeat;
    background-size: 100% 100%;
  }
  .new .content .pagination li.down{
    background:url("../assets/img/down.png")no-repeat;
    background-size: 100% 100%;
  }
  .new .content .pagination li a{
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  .new .content .pagination li.active a{
    background:#c21415;
    color:#fff;
  }
</style>
<template>
  <div class="new">
    <myhead></myhead>
    <div class="navbox">
      <nav class="nav">
        <img src="../assets/img/logo.png" alt=""/>
        <ul>
          <li @click="urlFun('/home')">首页</li>
          <li class="on" @click="urlFun('/news')">新闻</li>
          <li @click="urlFun('/rules')">规则</li>
          <li @click="urlFun('/videoList')">视频</li>
          <li @click="urlFun('/live')">直播</li>
        </ul>
      </nav>
    </div>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>新闻</div>
      <ul class="newList">
        <li v-for="(key,index) in newsList" @click="newFun(key.news_id)">
          <img :src="'http://admin.matchon.net//'+key.newsPic" alt=""/>
          <div class="text">
            <p class="title1">{{key.newsTitle}}</p>
            <p class="title2">{{key.introduction}}</p>
            <p class="gameIcon"><img :src="'http://admin.matchon.net/'+key.gameIcon" alt=""/>{{key.gameName}} <span>{{key.createTime}}</span></p>
          </div>
        </li>

      </ul>
      <ul class="pagination">
        <li class="up"><a @click="goto(current)" href="javascript:void(0)"></a></li>
        <li v-for="index in pages" @click="goto2(index)" :class="{'active':current == index}" :key="index"><a href="javascript:void(0)" >{{index}}</a></li>
        <li class="down"><a @click="goto3(current)" href="javascript:void(0)" ></a></li>
      </ul>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
    import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  export default {
//    name: 'New',
    components: {
      myhead,
      mybottom
    },
    data () {
      return {
        newsList:"",
//        分页
        current:1,
        showItem:10,
        allpage:1,
      }
    },

    computed:{
      pages(){
        var pag = [];
        var i=0;
        if( this.current < this.showItem ){
          i = Math.min(this.showItem,this.allpage);
          while(i){
            pag.unshift(i--);
          }
        }else{
          var middle = this.current - Math.floor(this.showItem / 2 ),
            i = this.showItem;
          if( middle >  (this.allpage - this.showItem)){
            middle = (this.allpage - this.showItem)+ 1
          }
          while(i--){
            pag.push( middle++ );
          }
        }
        return pag
      }
    },
    mounted(){
      this.newsData()
    },
    methods:{
      newsData(){
        let _this=this;
        let formd=new FormData()
        formd.append("rowNum",5)
        formd.append("isPaging",true)
        formd.append("seriesId",29)
        formd.append("page",this.current)
        this.$axios.post("http://admin.matchon.net//client/getNewsList",formd).then((data) => {
          if(data.data.code==200){
            _this.allpage=Math.ceil(data.data.data.total/5)
            _this.newsList=data.data.data.data;
            window.scrollTo(0,0);
          }
        });
    },
      urlFun(url){
        this.$router.push({path:url})
      },
      newFun(id){
        this.$router.push({path: '/NewDetails', query: {nid: id}})
      },
      //      分页
      goto(index){
        index--
        if(index<=0){
          this.current=1
          alert("当前是第一页")
        }else{
          this.current=index
          this.newsData()
        }
        console.log(index)
      },
      goto2(index){
        this.current=index
        this.newsData()
      },
      goto3(index){
        index++
        if(index>this.allpage){
          this.current=this.allpage
          alert("当前是最后一页")
        }else{
          this.current=index
          this.newsData()
        }
      },
    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/New.vue